<!-- Sign up layout wrapped with sidenav container -->
<mat-sidenav-container class="verification-sidenav-container">
  <mat-sidenav
    #verificationSidenav
    [mode]="'over'"
    position="end"
    [disableClose]="true"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0"
    class="verification-sidenav"
  >
    <!-- Verification -->
    <div *ngIf="verifyStep" class="sidenav-content verify-sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="sidenav-top-bar">
        <app-auto-registration-top-bar
          logoSrc="assets/img/glameraTradeMarkLogo2.png"
          [logoWidth]="132"
          [mobileLogoWidth]="110"
          languageColor="#000"
          [compact]="true"
          (watchVideo)="onOpenVideo()"
        ></app-auto-registration-top-bar>
      </div>
      <div *ngIf="isSmallViewport" class="mt-[24px] flex items-center justify-start">
        <div
          (click)="onCloseSidenav()"
          class="me-[12px] h-[18px] w-[18px] rounded-full bg-[#F9F9FA] flex items-center justify-center hover:bg-[#EDEDED] cursor-pointer transition-colors duration-200"
        >
          <svg [ngClass]="dir == 'ar' ? 'rotate-180' : ''" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.90625 0.28125L0.28125 2.90622M0.28125 2.90622L2.90625 5.53122M0.28125 2.90622H7.03125" stroke="#2F384C" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="m-0 font-[500] text-[16px] text-[#000]">{{ "Verification_Code" | translate }}</p>
      </div>
      <!-- Close button -->
      <button
        *ngIf="!isVerifyRoute && !isSmallViewport"
        mat-icon-button
        class="verify-close-btn"
        (click)="onCloseSidenav()"
        type="button"
        aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 16 16">
          <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button>

      <!-- Verification Component -->
      <app-verification
        [isVerifyRoute]="isVerifyRoute"
        [inlineRegistrationCycleLogId]="inlineRegistrationCycleLogIdForVerification"
        [inlineUser]="inlineUserForVerification"
        [inlineVerifyType]="verificationData?.verifyType"
        (closeSidebar)="onCloseSidebarFromVerification()"
      ></app-verification>
    </div>

    <!-- Reset Password -->
    <div *ngIf="resetStep" class="sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="sidenav-top-bar">
        <app-auto-registration-top-bar
          logoSrc="assets/img/glameraTradeMarkLogo2.png"
          [logoWidth]="132"
          [mobileLogoWidth]="110"
          languageColor="#000"
          [compact]="true"
          (watchVideo)="onOpenVideo()"
        ></app-auto-registration-top-bar>
      </div>
      <!-- <button
        mat-icon-button
        class="sidenav-close-btn"
        (click)="onCloseResetSidenav()"
        type="button"
        aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 16 16">
          <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button> -->
      <app-reset-password></app-reset-password>
    </div>

    <!-- Terms & Conditions / Privacy Policy -->
    <div *ngIf="termsStep" class="sidenav-content terms-sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="sidenav-top-bar">
        <app-auto-registration-top-bar
          logoSrc="assets/img/glameraTradeMarkLogo2.png"
          [logoWidth]="132"
          [mobileLogoWidth]="110"
          languageColor="#000"
          [compact]="true"
          (watchVideo)="onOpenVideo()"
        ></app-auto-registration-top-bar>
      </div>
      <div class="terms-header">
        <button
          mat-icon-button
          class="sidenav-close-btn"
          (click)="onCloseTermsSidenav()"
          type="button"
          aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 16 16">
            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
          </svg>
        </button>
        <h3 class="terms-title">
          {{ 'terms_and_conditions' | translate }}
        </h3>
      </div>
      <app-terms-condition></app-terms-condition>
    </div>
  </mat-sidenav>

  <!-- Main sign-up content -->
  <mat-sidenav-content>
    <div
      class="sign-up-layout sign-up-layout-local"
      fxLayout="row"
      fxLayoutAlign="start stretch"
    >
      <!-- Right Part -->
      <div
        class="sign-up-slider-part"
        [ngClass]="dir === 'ar' ? 'sign-up-slider-ar' : 'sign-up-slider-en'"
        fxFlex="40"
      >
        <img
          class="sign-up-slider-hero-img"
          [src]="dir === 'ar' ? 'assets/img/signup_ar.png' : 'assets/img/signup.png'"
          alt=""
        />
        <div class="sign-up-slider-topbar">
          <app-auto-registration-top-bar
            [logoSrc]="isSmallViewport ? 'assets/img/glameraTradeMarkLogo.png' : 'assets/img/glameraTradeMarkLogo2.png'"
            [logoWidth]="132"
            [mobileLogoWidth]="104"
            [compact]="true"
            [darkMode]="true"
            [languageColor]="isSmallViewport ? '#fff' : '#000'"
            (watchVideo)="onOpenVideo()"
          ></app-auto-registration-top-bar>
        </div>
        <img
          class="sign-up-logo sign-up-logo--desktop"
          src="assets/img/glameraTradeMarkLogo.png"
          width="190px"
          alt=""
          title=""
        />
        <main class="signup-main">
          <h2>{{ 'welocme_to_glamera' | translate }}</h2>
          <div class="d-flex text-center" style="white-space: pre-line;">
            <p>{{ 'ADOBT_GLAMERA' | translate }}</p>
          </div>
        </main>
      </div>
      <!-- Form Part -->
      <form
        class="sign-up-form-local"
        fxFlex="60"
        fxFlex.lt-md="100"
        fxLayout="column"
        fxLayoutAlign="start stretch"
        (submit)="onSubmit()"
        [formGroup]="form"
      >
        <div class="sign-up-watch-video sign-up-form-toolbar">
          <app-auto-registration-top-bar
            [showLogo]="false"
            (watchVideo)="onOpenVideo()"
          ></app-auto-registration-top-bar>
        </div>

        <div class="sign-up-fields-container mt-[4px] md:mt-[32px]">
          <main class="!py-0 sign-up-title-simple-steps">
            <h1>
              {{ 'START_YOUR_BUSINESS' | translate }}
            </h1>
            <p class="mb-0 mt-[12px] md:mt-[16px]">{{ 'SIMPLE_STEPS' | translate }}</p>
          </main>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px] mt-[24px] md:mt-[45px]">
            <mat-label class="label">{{ 'FULL_NAME' | translate }}</mat-label>
            <mat-form-field appearance="outline" class="br-20">
              <input
                matInput
                [placeholder]="'ENTER_FULL_NAME' | translate"
                formControlName="FirstName"
                [maxLength]="50"
              />
              <mat-error>
                <app-error-form
                  [name]="'FULL_NAME'"
                  [control]="form.controls['FirstName']"
                  [minLength]="2"
                  [maxLength]="50"
                ></app-error-form>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">{{ 'EMAIL' | translate }}</mat-label>
            <mat-form-field class="example-full-width" appearance="outline">
              <input
                type="email"
                matInput
                [placeholder]="'Enter_your_email' | translate"
                formControlName="Email"
              />
              <mat-error>
                <app-error-form
                  [name]="'EMAIL'"
                  [control]="form.controls['Email']"
                ></app-error-form>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">
              {{ 'AUTH.PHONE_NUMBER' | translate }}
            </mat-label>
            <div
              class="phone-row"
              fxLayout="row"
              fxLayoutAlign="start start"
              fxLayoutGap="10px"
            >
              <ng-container *ngIf="!countriesLoading; else phoneCountrySkeleton">
                <mat-form-field class="phone-country-code" appearance="outline">
                  <mat-select formControlName="CountryId">
                    <mat-select-trigger>
                      <ng-container *ngIf="form.controls['CountryId'].value">
                        <div class="d-flex align-items-center">
                          <img
                            style="border: 1px solid #ddd;"
                            [src]="getSelectedCountry()?.FlagPath"
                            width="24px"
                            alt=""
                          />
                          <span class="mx-1 text-xl">{{ getSelectedCountry()?.CallingCode }}</span>
                        </div>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.Id"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          style="border: 1px solid #ddd;"
                          [src]="country.FlagPath"
                          width="24px"
                          alt=""
                        />
                        <span class="mx-1 text-xl">{{ country.CallingCode }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #phoneCountrySkeleton>
                <div class="phone-country-code phone-country-code-skeleton"></div>
              </ng-template>

              <mat-form-field class="phone-number-input" appearance="outline">
                <input
                  matInput
                  [placeholder]="'ENTER_PHONE_NUMBER' | translate"
                  formControlName="MobileNumber"
                  [maxLength]="12"
                  appNumberOnly
                />
                <mat-error>
                  <app-error-form
                    [name]="'PHONE_NUMBER'"
                    [control]="form.controls['MobileNumber']"
                    [maxLength]="12"
                    [minLength]="4"
                  ></app-error-form>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">{{ 'PASSWORD' | translate }}</mat-label>
            <mat-form-field 
              appearance="outline" 
              subscriptSizing="dynamic" 
              class="password-form-field">
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                formControlName="Password"
                [placeholder]="'ENTER_PASSWORD' | translate"
                [maxLength]="20"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                [attr.aria-pressed]="hide"
                type="button"
              >
                @if (hide) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                    />
                    <path
                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                    />
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-eye-slash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                    />
                    <path
                      d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                    />
                    <path
                      d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                    />
                  </svg>
                }
              </button>
              <mat-error *ngIf="isPasswordInvalid">
                <app-error-form
                  [name]="'PASSWORD'"
                  [control]="form.controls['Password']"
                  [maxLength]="20"
                  [minLength]="6"
                ></app-error-form>
              </mat-error>
              <mat-error
                *ngIf="
                  form.controls['Password'].hasError('pattern') &&
                  (form.controls['Password'].dirty || form.controls['Password'].touched)
                "
              >
                {{ 'PASSWORD_MUST_CONTAIN_LETTERS_AND_NUMBERS' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="bt-1 !mt-[16px] md:!mt-[24px]">
            <mat-checkbox
              class="terms-conditions"
              formControlName="AgreeToPrivacyPolicy"
              color="primary"
            >
              <span>
                {{ 'AGREE_WITH' | translate }}
                <a
                  (click)="onOpenPrivacy($event)"
                  class="privacy"
                  >{{ 'PRIVACY_POLICY' | translate }}</a
                >
                {{ 'AND' | translate }}
                <a
                  (click)="onOpenPrivacy($event)"
                  class="terms-link"
                  >{{ 'TERMS_CONDITIONS' | translate }}</a
                >
              </span>
            </mat-checkbox>

            <button
              color="primary"
              type="submit"
              class="sign-up-submit-btn"
              [disabled]="form.invalid || loading"
            >
              {{ 'SIGN_UP' | translate }}
              <span class="btn-spinner-icon" *ngIf="loading"></span>
            </button>
          </div>

          <div class="login">
            <p>
              {{ 'HAVE_ACCOUNT' | translate }}
              <a class="text-xl" [href]="'https://' + appDomain + '/' + config.routes.LOGIN">{{
                'Login' | translate
              }}</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
